import { render, staticRenderFns } from "./CameraStepScreen.vue?vue&type=template&id=7ebff1bf&scoped=true&"
import script from "./CameraStepScreen.vue?vue&type=script&lang=js&"
export * from "./CameraStepScreen.vue?vue&type=script&lang=js&"
import style0 from "./CameraStepScreen.vue?vue&type=style&index=0&id=7ebff1bf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ebff1bf",
  null
  
)

export default component.exports